/*export const METRICS = "METRICS";
export const SEND_METRICS = "SEND_METRICS";*/
import youboraInfinity from './youboraInfinity';

const METRICS = "METRICS";
const SEND_METRICS = "SEND_METRICS";

export const metrics = (payload) => ({ type: METRICS, payload});
export const sendMetrics = (result) => ({ type: SEND_METRICS, result });

export function decodeHTML5(text){
	let rootElement = document.getElementById('root');
	let childText = document.createElement('textarea');
	let result = "";
	rootElement.appendChild(childText);
	childText.innerHTML = text;
	result = childText.value;
	rootElement.removeChild(childText);
	return result;
}

export const setMetricsEvent = (forwardingOptions)  =>  (dispatch, getState) => {
	if(forwardingOptions.eventLabel)
		forwardingOptions.eventLabel = decodeHTML5(forwardingOptions.eventLabel);
	const options = (forwardingOptions) ? forwardingOptions : {};
	if(options.type === 'executor') {
		const { metrics } = getState();

		// Se agregan los eventos para infinity
		// Youbora
		if(typeof window.youboraAnalyticsPlugin !== 'undefined') youboraInfinity(metrics);

		return dispatch(sendMetrics({
      executor: options,
      payload: metrics.payload
    }));
	}
	return dispatch(metrics(options));
}





// WEBPACK FOOTER //
// ./src/actions/metrics.js